import storage$1 from 'local-storage-fallback';
var storage = storage$1;
export { storage };